import type { INewbuildingHouseSchema } from '../../../../common/repositories/newbuilding-estimate/entities/newbuilding/NewbuildingHouseSchema';
import { INewbuildingSectionItem } from '../../../types/formFields';

export const newbuildingSectionsListMapper = (sections: INewbuildingHouseSchema[]): INewbuildingSectionItem[] => {
  return sections.map(({ id, name }) => ({
    label: name,
    value: id,
  }));
};
